import _styled, { default as _styled2, default as _styled3 } from "styled-components";
import { getThemeStyle, type Mode, type Theme } from "~/features/ui/get-theme-style";
import { Headline } from "~/features/ui/headline";
export type SpecsListSpecViewProps = {
  mode: Mode;
  subTitle?: string | null;
  theme: Theme;
  title?: string | null;
};
export function SpecsListSpecView({
  mode,
  subTitle,
  theme,
  title
}: SpecsListSpecViewProps) {
  const themeStyle = getThemeStyle({
    mode,
    theme
  });
  if (!title && !subTitle) {
    return null;
  }
  return <_StyledDiv $_css={[{
    "display": "flex",
    "height": "100%",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "gap": "var(--spacing-xs)",
    "paddingLeft": "1.6rem",
    "paddingRight": "1.6rem",
    "paddingTop": "4rem",
    "paddingBottom": "4rem",
    "textAlign": "center",
    "@media (min-width: 1024px)": {
      "paddingLeft": "4rem",
      "paddingRight": "4rem"
    }
  }]}>
      {title && <_StyledHeadline type="h3" text={title} $_css2={[{
      "fontSize": "2.2rem",
      "lineHeight": "1.2",
      "fontWeight": "400",
      "@media (min-width: 1024px)": {
        "fontSize": "2.4rem",
        "lineHeight": "1.3",
        "letterSpacing": "0.024rem",
        "fontWeight": "400"
      }
    }, themeStyle.text]} />}
      {subTitle && <_StyledP $_css3={[{
      "fontSize": "1.4rem",
      "lineHeight": "1.5",
      "letterSpacing": "0.014000000000000002rem",
      "fontWeight": "400",
      "color": "var(--text-transparent)",
      "@media (min-width: 1024px)": {
        "fontSize": "1.4rem",
        "lineHeight": "1.5",
        "letterSpacing": "0.014000000000000002rem",
        "fontWeight": "400"
      }
    }]}>{subTitle}</_StyledP>}
    </_StyledDiv>;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-sf-zsi2us-0"
})`${p => p.$_css}`;
var _StyledHeadline = _styled2(Headline).withConfig({
  componentId: "sc-sf-zsi2us-1"
})`${p => p.$_css2}`;
var _StyledP = /*#__PURE__*/_styled3("p").withConfig({
  displayName: "spec-list-spec___StyledP",
  componentId: "sc-183xg4w-0"
})(["", ""], p => p.$_css3);